const ROUTING_PREFIX = '@ROUTING/';
export const GET_ENTRY = `${ROUTING_PREFIX}_GET_ENTRY`;
export const SET_ENTRY = `${ROUTING_PREFIX}_SET_ENTRY`;
export const SET_NODE = `${ROUTING_PREFIX}_SET_NODE`;
export const SET_ANCESTORS = `${ROUTING_PREFIX}_SET_ANCESTORS`;
export const SET_SIBLINGS = `${ROUTING_PREFIX}_SET_SIBLINGS`;
export const SET_ENTRY_ID = `${ROUTING_PREFIX}_SET_ENTRY_ID`;
export const SET_SURROGATE_KEYS = `${ROUTING_PREFIX}_SET_SURROGATE_KEYS`;

export const SET_NAVIGATION_PATH = `${ROUTING_PREFIX}_SET_NAVIGATION_PATH`;

export const SET_TARGET_PROJECT = `${ROUTING_PREFIX}_SET_TARGET_PROJECT`;

export const SET_ROUTE = `${ROUTING_PREFIX}_SET_ROUTE`;

export const UPDATE_LOADING_STATE = `${ROUTING_PREFIX}_UPDATE_LOADING_STATE`;
